import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=61dc2c17"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=61dc2c17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports